import React from 'react';
import { classList } from 'utils/componentsCommon';

const ContentBoxContainer = ({ children, figure, className, ...props }) => {
    const classNames = classList('contentBoxContainer', className);

    return (
        <article className={ classNames } style={ figure !== undefined ? { backgroundImage: `url("${figure}")` } : undefined } { ...props }>
            { children }
        </article>
    );
};

export default ContentBoxContainer;
